import { type FilterValues } from "components/filters/FilterContext";
import { mapKeywordFilterToInstruction, mapResponseToKeywordFilter } from "components/filters/mappingUtils";

export const mapFilterValuesToInstruction = (
  filterSet: server.dto.FilterSets,
  filter: FilterValues,
  page: number,
  perPage: number
): server.dto.PaginatedProductGroupInstruction => {
  return {
    keyword: mapKeywordFilterToInstruction(filter.keyword),
    page,
    perPage,
    cache: filterSet
  };
};

export const mapResponseToFilterValues = (
  response: server.dto.ListProductGroupFilters
): Partial<FilterValues> => ({
  keyword: mapResponseToKeywordFilter(response.keyword),
});